/**
 * The dynamic range of a video quality.
 */
export enum DynamicRange {
  /**
   * Standard Dynamic Range.
   */
  SDR = 'sdr',
  /**
   * High Dynamic Range.
   */
  HDR = 'hdr',
  /**
   * The dynamic range could not be determined.
   */
  Unknown = 'unknown',
}
